<template>
    <v-layout row fill-height align-center justify-center>
        <v-flex md4 text-xs-center>
            <h4 class="font-weight-bold display-1  " style="color:#AFBAC8">Page Not Found!!</h4>
            <v-btn class="mt-4" block flat color="bindezcolor" dark :to="{name: 'monitor-list'}">
                <span class="text-capitalize">Back To Monitor List Page</span>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
	export default {
		name: "NotFound"
	}
</script>

<style scoped>

</style>
